export const hubMSPSortColumns = [
  'id',
  'statusName',
  'summary',
  'priorityName',
  'dateEntered',
  'lastUpdated',
  'boardName',
  'contactFullName',
] as const;

export type HubMSPSortColumn = (typeof hubMSPSortColumns)[number];
